import {api} from "./api.service";

export class QuestionService {
    static async getQuestion(data) {
        return api.get("question", {
            params: data,
        });

    }

}

